import React, { useEffect, useState } from "react";
import { baseUrl, userHasModules } from '../shared';
import AppShell from '../components/AppShell';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import AssetView from './assetView'
import Home from './home'
import Login from '../components/login'
import Create from './create/createAsset'
import Admin from './admin'
import OpenRepairs from "./openRepairs";
import Logout from './logout'
import ResetPassword from './resetPassword'
import TimesheetReview from './timesheetReview'
import NoPage from './NoPage'
import './App.css';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ExcelExport from "../components/excelExports";
import PlatformDashboard from './reporting/platformDashboard';
import ScheduleReport from './reporting/scheduleReport';
import AdminTimesheetReport from './reporting/adminTimesheetReport';
import Scheduling from './scheduling';
import Workshop from './workshop';
import WorkshopSettings from './workshop/WorkshopSettings';
import NonApprovals from './workshop/NonApprovals';
import WorkshopStats from './workshop/WorkshopStats';
import WorkshopHours from './workshop/WorkshopHours';
import CylinderReference from './workshop/CylinderReference';
import Inspection from './inspection';
import Defects from './defects';

// Home is the modules grid. Old QR codes / deep links hit "/?catNo=" or
// "/?assetNo=" — redirect those to /assets so they keep working.
function HomeRoute() {
  const loc = useLocation();
  const params = new URLSearchParams(loc.search);
  const loggedIn = localStorage.getItem('username') !== null;
  if (params.get('assetNo') || params.get('catNo')) {
    return <Navigate to={'/assets' + loc.search} replace />;
  }
  if (!loggedIn) return <Login />; // branded full-page login
  // Scan-only user (no module perms) → straight to Assets; otherwise the modules grid.
  return userHasModules() ? <Home /> : <Navigate to="/assets" replace />;
}

function App() {

  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = useState('');

  const handleClose = () => {
    setOpen(false);
    logOutUser();
  };

  const logOutUser = () => {
    const url = baseUrl + 'user/logout';
fetch(url, {
  method: 'POST',
  headers: {
      'username': localStorage.getItem('username'),
      'bToken': localStorage.getItem('bToken')
  }})
.then((response) => response.json())
.then((data) => {
    console.log('logout',data);
    localStorage.clear();
    window.location.href='/'
})
.catch((err) => {
   console.log(err.message);
});
};

  const checkValidLogin = async () => {
    const url = baseUrl + 'user/validLogin';
      await fetch(url, {
        method: 'GET',
        headers: {
            'username': localStorage.getItem('username'),
            'bToken': localStorage.getItem('bToken')
        }})
      .then((response) => response.json())
      .then((data) => {
        console.log(data)
        if( data.status === "200") {
        localStorage.setItem("canSearch", data.canSearch)
        localStorage.setItem("canAddAsset", data.canAddAsset)
        localStorage.setItem("canEditAsset", data.canEditAsset)
        localStorage.setItem("canDeleteAsset", data.canDeleteAsset)
        localStorage.setItem("canInspectAsset", data.canInspectAsset)
        localStorage.setItem("canAddAttachment", data.canAddAttachment)
        localStorage.setItem("canRegisterUser", data.canRegisterUser)
        localStorage.setItem("canUpdateUser", data.canUpdateUser)
        localStorage.setItem("canBulkAdd", data.canBulkAdd)
        localStorage.setItem("canAddDefect", data.canAddDefect)
        localStorage.setItem("canViewPlatformDashboard", data.canViewPlatformDashboard)
        localStorage.setItem("canViewSchedule", data.canViewSchedule)
        localStorage.setItem("canManageSchedule", data.canManageSchedule)
        localStorage.setItem("canUseOmnixIntegration", data.canUseOmnixIntegration)
        localStorage.setItem("canManageWorkshop", data.canManageWorkshop)
        localStorage.setItem("canViewWorkshopHistory", data.canViewWorkshopHistory)
        localStorage.setItem("canUseDetailedInspection", data.canUseDetailedInspection)
        localStorage.setItem("canAdminReport", data.canAdminReport)
        } else if (data.status === 401) {
          setMessage(data.message);
          setOpen(true);
        }
      })
      .catch((err) => {
         console.log(err.message);
      }); 
  }

  useEffect(() => {
    if(localStorage.getItem('username') !== null){
      checkValidLogin()
    }
    }, []); 

  const loggedIn = localStorage.getItem('username') !== null;

  const routes = (
    <Routes>
      <Route>
        <Route path="/" exact element={<HomeRoute />} />
        <Route path="assets" element={<AssetView />} />
        <Route path="createAsset" element={localStorage.getItem('canAddAsset') === '1' ? <Create /> : <Navigate to="/" replace />} />
        <Route path="timesheetReview" element={localStorage.getItem('canInspectAsset') === '1' ? <TimesheetReview /> : <Navigate to="/" replace />} />
        <Route path="exportfile" element={localStorage.getItem('canSearch') === '1' ? <ExcelExport /> : <Navigate to="/" replace />} />
        <Route path="openRepairs" element={localStorage.getItem('canInspectAsset') === '1' ? <OpenRepairs /> : <Navigate to="/" replace />} />
        <Route path="admin" element={localStorage.getItem('canRegisterUser') === '1' ? <Admin /> : <Navigate to="/" replace />} />
        <Route path="logout" element={<Logout />} />
        <Route path="resetPassword" element={<ResetPassword />} />
        <Route path="reporting/platform-dashboard" element={localStorage.getItem('canViewPlatformDashboard') === '1' ? <PlatformDashboard /> : <Navigate to="/" replace />} />
        <Route path="reporting/schedule-report" element={localStorage.getItem('canManageSchedule') === '1' ? <ScheduleReport /> : <Navigate to="/" replace />} />
        <Route path="reporting/admin-timesheet-report" element={localStorage.getItem('canAdminReport') === '1' ? <AdminTimesheetReport /> : <Navigate to="/" replace />} />
        <Route path="scheduling" element={localStorage.getItem('canViewSchedule') === '1' || localStorage.getItem('canManageSchedule') === '1' ? <Scheduling /> : <Navigate to="/" replace />} />
        <Route path="workshop" element={localStorage.getItem('canManageWorkshop') === '1' ? <Workshop /> : <Navigate to="/" replace />} />
        <Route path="workshop/settings" element={localStorage.getItem('canManageWorkshop') === '1' ? <WorkshopSettings /> : <Navigate to="/" replace />} />
        <Route path="workshop/non-approvals" element={localStorage.getItem('canManageWorkshop') === '1' ? <NonApprovals /> : <Navigate to="/" replace />} />
        <Route path="workshop/stats" element={localStorage.getItem('canManageWorkshop') === '1' ? <WorkshopStats /> : <Navigate to="/" replace />} />
        <Route path="workshop/hours" element={localStorage.getItem('canManageWorkshop') === '1' ? <WorkshopHours /> : <Navigate to="/" replace />} />
        <Route path="workshop/cylinder-reference" element={localStorage.getItem('canManageWorkshop') === '1' ? <CylinderReference /> : <Navigate to="/" replace />} />
        <Route path="inspection" element={localStorage.getItem('canUseDetailedInspection') === '1' || localStorage.getItem('canInspectAsset') === '1' ? <Inspection /> : <Navigate to="/" replace />} />
        <Route path="defects" element={localStorage.getItem('canAddDefect') === '1' || localStorage.getItem('canInspectAsset') === '1' ? <Defects /> : <Navigate to="/" replace />} />
        <Route path="*" element={<NoPage />} />
      </Route>
    </Routes>
  );

 return (
  <>
  <React.Fragment>
  <Dialog
    open={open}
    onClose={handleClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="confirmDeleteTitle">
    </DialogTitle>
    <DialogContent>
      <DialogContentText id="confirmDeleteDesc">
        {message}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleClose}>
        OK
      </Button>
    </DialogActions>
  </Dialog>
</React.Fragment>
  <Router>
   {loggedIn ? (
     <AppShell>{routes}</AppShell>
   ) : (
     // Logged out: the branded full-page Login is self-contained (its own logo);
     // no Header/Footer chrome needed.
     <>{routes}</>
   )}
 </Router>
</>
 )
}

export default App